import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const NewsBanner = () => {
  return (
    <section className="py-20 md:py-32 relative bg-ninsun-surface border-y border-gray-200">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-ninsun-text tracking-tight">Latest News</h2>
            <Link 
              to="/news" 
              className="hidden md:inline-flex items-center space-x-2 text-ninsun-gold hover:opacity-80 font-bold font-mono text-sm tracking-widest uppercase transition-opacity"
            >
              <span>View All News</span>
              <ArrowRight size={18} />
            </Link>
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            
            {/* Clickable News Announcement */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="lg:col-span-2"
            >
              <Link to="/news" className="block glass-panel p-8 md:p-10 rounded-2xl group hover:border-ninsun-gold/50 transition-all duration-300 hover:shadow-md h-full flex flex-col justify-center">
                <div className="mb-4">
                  <span className="font-mono text-ninsun-gold font-bold tracking-widest text-sm uppercase">2026, June 18</span>
                  <h3 className="text-2xl md:text-3xl font-display font-bold text-ninsun-text mt-3 group-hover:text-ninsun-gold transition-colors">Onco Startup Summit 2026</h3>
                </div>
                <p className="text-ninsun-muted leading-relaxed text-lg mb-8">
                  Ninsun Biotech is selected among 48 startups in oncology to present an e-poster at the Onco Startup Summit held in Paris, France, during the French national congress of Oncology organized by IFODS.
                </p>
                <div className="inline-flex items-center space-x-2 text-ninsun-text font-bold mt-auto group-hover:text-ninsun-gold transition-colors">
                  <span>Read Full Story</span>
                  <ArrowRight size={18} className="transform group-hover:translate-x-1 transition-transform" />
                </div>
              </Link>
            </motion.div>

            {/* CTA to Contact Page */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <div className="glass-panel p-8 md:p-10 rounded-2xl bg-white h-full flex flex-col justify-center text-center">
                <div className="w-16 h-16 bg-ninsun-gold/10 text-ninsun-gold rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg xmlns="http://www.w3.org/0000.svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-ninsun-text mb-4 tracking-tight">Request the e-poster</h3>
                <p className="text-ninsun-muted mb-8 text-sm md:text-base">
                  Get full access to our latest research findings and methodology.
                </p>
                <Link 
                  to="/contact" 
                  className="w-full bg-ninsun-gold text-white font-bold py-4 px-6 rounded-lg hover:opacity-90 transition-opacity shadow-sm flex items-center justify-center gap-2"
                >
                  <span>Request the e-poster</span>
                  <ArrowRight size={18} />
                </Link>
              </div>
            </motion.div>

          </div>
          
          {/* Mobile View All Link */}
          <div className="mt-8 text-center md:hidden">
            <Link 
              to="/news" 
              className="inline-flex items-center space-x-2 text-ninsun-gold hover:opacity-80 font-bold font-mono text-sm tracking-widest uppercase transition-opacity"
            >
              <span>View All News</span>
              <ArrowRight size={18} />
            </Link>
          </div>

        </div>
      </div>
    </section>
  );
};

export default NewsBanner;